"use client";

import { useToast, ToasterToast } from "./use-toast.ts";
import {
  Toast,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  AuthToastViewport,
} from "./toast.tsx";
import { AlertCircle } from "lucide-react";

export function AuthToaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }: ToasterToast) {
        return (
          <Toast key={id} {...props}>
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full border border-red-500 flex items-center justify-center">
                  <AlertCircle className="w-4 h-4 text-red-500" />
                </div>
              </div>
              <div className="flex-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
          </Toast>
        );
      })}
      <AuthToastViewport />
    </ToastProvider>
  );
} 